/** Shared CRM onboarding lookup / option constants */

export const SITE_TYPE_OPTIONS = [
  "Commercial",
  "Industrial",
  "Residential",
  "Warehouse",
  "Remote"
];

export const ASSET_STATUS_OPTIONS = ["Active", "Inactive"];

export const WARRANTY_TYPE_OPTIONS = ["Yes", "No"];

export const AMC_TYPE_OPTIONS = ["Comprehensive", "Non Comprehensive", "No AMC"];
